<div class="container">
  <div class="content">
    @if (nuevoAcuerdo) {
    <app-nuevo-acuerdo></app-nuevo-acuerdo>
    }@else {
    <mat-card *ngIf="dataSource$ | async as dataSource" class="!m-4">
      <mat-card-content class="acuerdos-listado-header !flex !justify-between">
        <div class="!flex !justify-start items-center">
          <div class="!flex !gap-3 items-center">
            <h1 class="!m-0" style="font-size: 20px;font-weight: 500;">ACUERDO MR. B.</h1>

            <button
              (click)="picker.open()"
              [color]="'primary'"
              mat-mini-fab
              aria-label="Filtro por fecha Acuerdo Mr. B.">
              <mat-icon>date_range</mat-icon>
            </button>
          </div>
          <div>
            <mat-form-field class="example-full-width" style="display: none">
              <mat-label>Selecciona una fecha</mat-label>
              <input matInput [matDatepicker]="picker" />
              <mat-hint>MM/DD/YYYY</mat-hint>
              <mat-datepicker-toggle
                matIconSuffix
                [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker [dateClass]="dateClass" touchUi #picker>
              </mat-datepicker>
            </mat-form-field>
          </div>
        </div>

        <form>
          <ng-container>
            <mat-radio-group
              name="acuerdoSeleccionado"
              aria-labelledby="example-radio-group-label"
              class="radio-group"
              color="warn"
              [(ngModel)]="acuerdoSeleccionado"
              (change)="onChangeSelection($event.value)">
              @for (acuerdo of catAcuerdo; track acuerdo) {
              <mat-radio-button
                color="warn"
                class="acuerdos-tipo"
                [value]="acuerdo.tipoAcuerdo"
                >{{ acuerdo.descripcion }}</mat-radio-button
              >
              }
            </mat-radio-group>
          </ng-container>
        </form>
      </mat-card-content>

      <mat-card-content>
        <ng-container *ngIf="tipoAcuerdo === 3">
          <form
            [formGroup]="formHistorico"
            class="!grid !grid-cols-4 !items-center !gap-4 !mt-4">
            <mat-form-field class="mat-form-field-combo">
              <mat-label>Mes</mat-label>
              <mat-select formControlName="mes" name="mes" placeholder="mes">
                <mat-option *ngFor="let item of meses" [value]="item.id">
                  {{ item.mes }}
                </mat-option>
              </mat-select>
              @if (formHistorico.get('mes')?.invalid &&
              formHistorico.get('mes')?.touched) {
              <mat-error>Campo obligatorio.</mat-error>
              }
            </mat-form-field>

            <mat-form-field class="mat-form-field-combo">
              <mat-label>Año</mat-label>
              <mat-select formControlName="anio" name="anio" placeholder="Año">
                <mat-option *ngFor="let item of anios" [value]="item.anio">
                  {{ item.anio }}
                </mat-option>
              </mat-select>
              @if (formHistorico.get('anio')?.invalid &&
              formHistorico.get('anio')?.touched) {
              <mat-error>Campo obligatorio.</mat-error>
              }
            </mat-form-field>

            <div class="!flex !gap-3 justify-end col-span-2">
              <button
                (click)="getAcuerdosPorMA()"
                mat-stroked-button
                class="!uppercase">
                Consultar
              </button>
              <button
                (click)="getAcuerdos()"
                mat-stroked-button
                class="!uppercase">
                Ver todo
              </button>

              <button
                (click)="downloadHistorico()"
                [disabled]="!showHistorico"
                mat-flat-button
                class="!uppercase"
                color="primary"
                extended>
                <mat-icon>cloud_download</mat-icon>
                Descargar
              </button>
            </div>
          </form>
        </ng-container>
      </mat-card-content>
      <mat-card-content>
        <ng-container *ngIf="dataSource.length > 0; else noData">
          <app-table-mrb [data]="dataSource"></app-table-mrb>
        </ng-container>
      </mat-card-content>

      <ng-template #noData>
        <div class="!p-3 !shadow"></div>
      </ng-template>
    </mat-card>
    }

    <button
      *ngIf="tipoAcuerdo == 2 && !nuevoAcuerdo"
      (click)="nuevoAcuerdoMRB()"
      class="fixed-button"
      mat-fab
      color="warn"
      aria-label="Remove file">
      <mat-icon>add</mat-icon>
    </button>
  </div>
</div>
